import { azureFetch } from "./azureFetch";

export const fetchFilterData = async(filters) => {
    try {
        const response = await azureFetch('filter-data', {where_clause: filters});
        return response.data;
    } catch (error) {
        console.error("Error fetching filter data:", error);
        throw error;
    }
};

export const fetchSensorData = async (filters, limit, offset, order_by, order_dir) => {
    try {
        const response = await azureFetch('sensor-data', {
            where_clause: filters,
            limit,
            offset,
            order_by,
            order_dir
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor data:", error);
        throw error;
    }
};

export const fetchSensorCount = async (filters) => {
    try {
        const response = await azureFetch('sensor-count', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching sensor count:", error);
        throw error;
    }
};

export const fetchCmlCardData = async (filters) => {
    try {
        const response = await azureFetch('cmlCard-data', {
            where_clause: filters
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching CML card data:", error);
        throw error;
    }
};

export const fetchLTRemnantData = async (filters, currentDateISO, maxExpiryDateISO) => {
    try {
        const response = await azureFetch('LTRemnant-data', {
            where_clause: filters,
            currentDateISO,
            maxExpiryDateISO
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching LT remnant data:", error);
        throw error;
    }
};

export const fetchSTRemnantData = async (filters, currentDateISO, maxExpiryDateISO) => {
    try {
        const response = await azureFetch('STRemnant-data', {
            where_clause: filters,
            currentDateISO,
            maxExpiryDateISO
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching ST remnant data:", error);
        throw error;
    }
};